<template>
  <aside class="right-aside">
    <!-- Main content -->
    <section class="content">
      <slot></slot>
    </section>
    <!-- /.content -->
  </aside>
</template>
<script>
export default {
  name: "right-side",
};
</script>
<style lang="scss" scoped>
.content {
  height: 100%;
}
.right-aside {
  position: fixed;
  top: 64px;
  width: 100%;
  max-height: 100%;
  height: calc(100% - 64px);
  left: 0;
  right: 0;
  overflow-y: auto;

  width: 100%;
  max-width: 100%;
  .content-header > h1 {
    margin: 2px;
    padding-left: 13px;
    padding-top: 12px;
    font-size: 20px;
    line-height: 1.5;
  }
  .content-header {
    margin: -2px 0px 0px 0px;
    height: 55px;
    background: #f9fafb;
    box-shadow: 3px 1px 5px #ccc;
  }
}
</style>
